import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import noVisitada from "../icons/noVisitada.svg"
import { withRouter } from "../providers/withRouter";
import Swal from 'sweetalert2';
import { Tooltip } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material';
import { UsuarioContext } from "../providers/userContext";
import { formatoFechas, formatoFechasEs } from '../functions/funciones';
import { noRealizada } from '../services';
import { toast } from "react-toastify";
import { FaEye } from "react-icons/fa";
const theme = createTheme();



const NoVisitado = (props) => {
  const { t } = useTranslation('common');
  const user = useContext(UsuarioContext)
  // let finca = props.finca  
  const [noRealizado, setNoRealizado] = useState(false);
  const [ObsTexto, setObsTexto] = useState('');
  const [fecha, setFecha] = useState('');
  const [CommTexto, setCommTexto] = useState('');
  const [recargar, setRecargar] = useState(false);
  const [finca, setFinca] = useState(props.finca);
  const [visitado, setVisitado] = useState(false);

  useEffect(() => {
    if (props.tipo === 'finca') {
      setVisitado(finca.detailsCae[0]?.visitada);
      if (finca.detailsCae[0]) {
        if (finca.detailsCae[0]?.unRealized !== false && finca.properties.nif === props.nif) {
          setNoRealizado(finca.detailsCae[0]?.unRealized);
          setObsTexto(finca.detailsCae[0]?.observaciones)
          setCommTexto(finca.detailsCae[0]?.comentarios)
          setFecha(formatoFechasEs(finca.detailsCae[0]?.unrealizedDate))
        }
      }
    }

    if (props.tipo === 'centroTrabajo') {
      setVisitado(finca.workSales[0]?.detailsCae?.[0]?.visitada);
      if (finca.id === props.nif && finca.workSales[0]?.detailsCae[0]?.unRealized !== false) {
        setNoRealizado(finca.workSales[0]?.detailsCae[0]?.unRealized)
        setObsTexto(finca.workSales[0]?.detailsCae[0]?.observaciones)
        setCommTexto(finca.workSales[0]?.detailsCae[0]?.comentarios)
        setFecha(formatoFechasEs(finca.workSales[0]?.detailsCae[0]?.unrealizedDate))
      }
    }
  }, [finca, recargar])


  const handleCallback = () => {
    setRecargar(!recargar);
    setNoRealizado(true)
  };

  const comprobar = async () => {

    handleAdd().then((resultado) => {
      handleCallback(resultado)
    })
  };

  const handleAdd = () => {
    return new Promise(async (resolve, reject) => {
      let toastInfo = undefined
      try {
        Swal.fire({
          title: t('visits.noVisitReason'),
          html: `<select id="motivoTexto" style="width: 373px; height: auto; font-size:14px; padding:10px; border: 1px solid #d9d9d9; border-radius: .1875em; box-shadow: inset 0 1px 1px rgba(0, 0, 0, .06), 0 0 0 3px rgba(0, 0, 0, 0);" className="swal2-input" >
                    <option>${t('visits.notAllowedEntry')}</option>
                    <option>${t('visits.garageNoKey')}</option>
                    <option>${t('visits.propertyNotFound')}</option>
                    <option>${t('visits.others')}</option>
                  </select>
                  <textarea id="motivoComentario" placeholder="${t('visits.specifyReason')}" style="width: 373px; height: 150px; font-size:13px; padding:10px;" class="swal2-textarea"></textarea>
                  <div id="charCounter" style="width: 373px; text-align: right; font-size: 12px; color: #888; margin-top: -8px;">0 / 200</div>  
                  `,
          confirmButtonText: t('actions.save'),
          confirmButtonColor: '#05811b',
          showCancelButton: true,
          cancelButtonText: t('actions.cancel'),
          cancelButtonColor: '#d33',
          showDenyButton: noRealizado ? true : false,
          denyButtonText: t('visits.removeNoVisitReason'),
          denyButtonColor: `#33383b`,
          focusConfirm: false,

          didOpen: () => {
            const select = Swal.getPopup().querySelector('#motivoTexto');
            const textarea = Swal.getPopup().querySelector('#motivoComentario');
            textarea.style.color = '#000000';
            const counter = Swal.getPopup().querySelector('#charCounter');
            const confirmBtn = Swal.getConfirmButton();
            const MAX_CHAR = 200;

            const updateCounter = () => {
              const len = textarea.value.length;
              counter.textContent = `${len} / ${MAX_CHAR}`;

              if (len > MAX_CHAR) {
                counter.style.color = '#d33';
                textarea.style.color = '#d33';
                confirmBtn.disabled = true;
                confirmBtn.style.opacity = '0.5';
                confirmBtn.style.cursor = 'not-allowed';

              } else {
                counter.style.color = len >= MAX_CHAR * 0.85 ? '#e67e22' : '#888';
                confirmBtn.disabled = false;
                confirmBtn.style.opacity = '1';
                confirmBtn.style.cursor = 'pointer';
                textarea.style.color = '#000000';
              }
  
            };

            if (select && ObsTexto) {
              select.value = ObsTexto.trim();
            }
            if (textarea && CommTexto) {
              textarea.value = CommTexto;
              updateCounter();
            }
            textarea.addEventListener('input', updateCounter);
          },

          preConfirm: () => {
            toastInfo = toast.info(t('documents.savingData'), { autoClose: false });
            const texto = Swal.getPopup().querySelector('#motivoTexto').value
            const comentario = Swal.getPopup().querySelector('#motivoComentario').value
            if (!texto) {
              Swal.showValidationMessage(t('visits.insertText'))
            }
            if (comentario.length > 200) {
              Swal.showValidationMessage(`El comentario supera los 200 caracteres (${comentario.length - 200} de más)`);
              return false;
            }
            return { texto: texto, comentario }
          }


        }).then(async (result) => {
          if (result.isConfirmed) {
            const datos = {
              unRealized: true,
              unrealizedDate: formatoFechas(new Date()),
              observaciones: result.value.texto,
              comentarios: result.value.comentario
            }

            await noRealizada(finca.id, datos).then(() => {
              toast.update(toastInfo, {
                render: t('visits.dataSavedSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true
              });
              resolve(true);
            })
            let fincaUpdated = {
              ...finca,
              detailsCae: finca.detailsCae.map((detalle, index) =>
                index === 0 ? { ...detalle, ...datos } : detalle
              )
            }
            setFinca(fincaUpdated)
          }
          else if (result.isDenied) {
            const datos = {
              unRealized: false,
              unrealizedDate: null,
              observaciones: null,
              comentarios: null
            }
            setObsTexto('')
            setCommTexto('')
            await noRealizada(finca.id, datos).then(() => {
              toast.update(toastInfo, {
                render: t('visits.updatingChanges'),
                type: toast.TYPE.SUCCESS,
                autoClose: true
              });
              resolve(true);
            })
            let fincaUpdated = {
              ...finca,
              detailsCae: finca.detailsCae.map((detalle, index) =>
                index === 0 ? { ...detalle, ...datos } : detalle
              )
            }
            setFinca(fincaUpdated);
            setNoRealizado(false);

          }
        })
      } catch (error) {
        reject(error);
      }
    })
  }

  const formattedCommTexto = "<br/>Comentarios: <br/>" + CommTexto?.replace(/\n/g, '<br/>');

  const esCoorAsignado = user.rol === "TECH_COOR" && finca?.aaff?.technicians?.some(tech => tech.id === user.id);

  return (
    <>
      {(visitado === undefined || visitado === null || visitado === false) && (
        <>
          {(user.rol === 'TECH' || esCoorAsignado) && !noRealizado && (
            <button type="button" className='btn' onClick={comprobar}>
              <FaEye />
            </button>
          )}
          {noRealizado && (
            <>
              <button type="button" style={{ padding: 0 }} className='btn' onClick={comprobar}>
                <ThemeProvider theme={theme}>

                  <Tooltip title={
                    <>
                      <div>{fecha} - {ObsTexto}</div>
                      <div>
                        <span dangerouslySetInnerHTML={{
                          __html: CommTexto ? formattedCommTexto : '',
                        }}>
                        </span>
                      </div>
                    </>
                  } >
                    <img src={noVisitada} alt="No visitado" className="tableIcon" />
                  </Tooltip>
                </ThemeProvider>
              </button>
            </>
          )}
        </>
      )}
    </>
  );
}

export default withRouter(NoVisitado);